import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Navigate,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ToolsPage from './pages/ToolsPage';
import GetInvolvedPage from './pages/GetInvolvedPage';
import WhatsNextPage from './pages/WhatsNextPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import LabStories from './pages/LabStories';
import ExperimentationZonePage from './pages/ExperimentationZonePage';
import ExperimentationAcademyPage from './pages/ExperimentationAcademyPage';
import FellowshipsPage from './pages/FellowshipsPage';
import ProgrammeApplicationPage from './pages/ProgrammeApplicationPage';
import ProgrammeAccessPage from './pages/ProgrammeAccessPage';
import ProgrammeLoginPage from './pages/ProgrammeLoginPage';
import ProgrammePortalPage from './pages/ProgrammePortalPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import SearchResultsPage from './pages/SearchResultsPage';
import CareersPage from './pages/CareersPage';
import JobDetailPage from './pages/JobDetailPage';
import NotFoundPage from './pages/NotFoundPage';
import SupernovaToolsPage from './pages/SupernovaToolsPage';
import ToolShowcasePage from './pages/ToolShowcasePage';
import ToolWorkspacePage from './pages/ToolWorkspacePage';
import CustomCursor from './components/CustomCursor';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppShell() {
  const { pathname } = useLocation();
  const isToolWorkspace =
    pathname.startsWith('/supernova-tools/') &&
    pathname !== '/supernova-tools/';
  const isEmbeddedToolExperience =
    /^\/supernova-tools\/[^/]+\/embed\/?$/.test(pathname);
  const isProgrammePortal =
    pathname === '/experimentation-zone/portal' ||
    pathname === '/fellowships/portal';
  const isProductWorkspace = isToolWorkspace || isProgrammePortal;

  return (
    <>
      <CustomCursor />
      <ScrollToTop />
      <div className={`App ${isProductWorkspace ? 'App--tool-workspace' : ''}`}>
        {isProgrammePortal || isEmbeddedToolExperience ? null : <Header />}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/tools" element={<ToolsPage />} />
          <Route path="/supernova-tools" element={<SupernovaToolsPage />} />
          <Route
            path="/supernova-tools/:slug/embed"
            element={<ToolWorkspacePage embedded />}
          />
          <Route
            path="/supernova-tools/:slug"
            element={<ToolShowcasePage />}
          />
          <Route
            path="/tool-store"
            element={<Navigate replace to="/supernova-tools" />}
          />
          <Route path="/get-involved" element={<GetInvolvedPage />} />
          <Route path="/whats-next" element={<WhatsNextPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/search" element={<SearchResultsPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/lab-stories" element={<LabStories />} />
          <Route
            path="/experimentation-academy"
            element={<ExperimentationAcademyPage />}
          />
          <Route
            path="/experimentation-zone"
            element={<ExperimentationZonePage />}
          />
          <Route
            path="/experimentation-zone/apply"
            element={<ProgrammeApplicationPage kind="zone" />}
          />
          <Route
            path="/experimentation-zone/login"
            element={<ProgrammeLoginPage kind="zone" />}
          />
          <Route
            path="/experimentation-zone/access"
            element={<ProgrammeAccessPage kind="zone" />}
          />
          <Route
            path="/experimentation-zone/forgot-password"
            element={<ProgrammeAccessPage kind="zone" mode="reset" />}
          />
          <Route
            path="/experimentation-zone/portal"
            element={<ProgrammePortalPage kind="zone" />}
          />
          <Route path="/fellowships" element={<FellowshipsPage />} />
          <Route
            path="/fellowships/apply"
            element={<ProgrammeApplicationPage kind="fellowship" />}
          />
          <Route
            path="/fellowships/login"
            element={<ProgrammeLoginPage kind="fellowship" />}
          />
          <Route
            path="/fellowships/access"
            element={<ProgrammeAccessPage kind="fellowship" />}
          />
          <Route
            path="/fellowships/forgot-password"
            element={<ProgrammeAccessPage kind="fellowship" mode="reset" />}
          />
          <Route
            path="/fellowships/portal"
            element={<ProgrammePortalPage kind="fellowship" />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/careers/:slug" element={<JobDetailPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>

        {isProductWorkspace ? null : <Footer />}
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;
